import type { ConfigurationParameters } from '@ory/client/configuration';

export const oryConfig: ConfigurationParameters = {
  basePath: process.env.REACT_APP_API_ORY_SDK_URL,
  baseOptions: {
    withCredentials: true,
  },
};
